// Breadcrumbs
import Breadcrumbs from '@/components/ui/Breadcrumbs'

// Table
import RetailerInvoiceTable from '@/components/retailers/RetailerInvoiceTable'

export default function RetailerInvoicesIndex() {
    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Factures revendeurs',
        },
    ]

    return (
        <div>
            <Breadcrumbs breadcrumbs={breadcrumbs} />

            <RetailerInvoiceTable />
        </div>
    )
}
